import { useAppCallback } from '@kizenapps/engine/react';
import Loader from 'components/Kizen/Loader';
import { Redirect, useLocation } from 'react-router-dom';

export const PluginCallbackPage = () => {
  const location = useLocation();

  useAppCallback(location.search);

  if (window.parent === window) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <Loader loading />
    </div>
  );
};
